<template>
  <b-row class="mb-1" align-v="center">
    <b-col md="2">
      <label>Numero de registros</label>
      <v-select
        v-model="porPagina"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="perPageOptions"
        :clearable="false"
        class="per-page-selector"
        @input="changePerPage"
      />
    </b-col>
    <b-col md="4">
      <label>Buscar en tabla</label>
      <div class="d-flex">
        <b-form-input
          v-model="filter.queryBenefits"
          class="mr-1"
          placeholder="Buscar..."
          type="search"
          @input="setFilter"
        />
      </div>
    </b-col>
    <b-col>
      <b-button
        @click="refreshData"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-2"
        :disabled="isLoadingSomething"
      > <feather-icon icon="RefreshCwIcon" style="color: white" />
      </b-button>
    </b-col>
    <b-col md="">
      <div class="mt-2">
        <b-button
          :to="{name: 'create-benefits'}"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="float-right"
          v-b-tooltip.hover.left="'Dar de alta beneficio'"
        > <feather-icon icon="PlusIcon" style="color: white" />
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapMutations, mapState, } from 'vuex'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  props:{
    perPage:{
      type: Number,
      required: true,
    },
    perPageOptions:{
      type: Array,
      required: true,
    },
    searchQuery:{
      type: String,
      required: true,
    },
    isLoadingSomething:{
      type: Boolean,
      required: true
    }
  },
  components: {
    vSelect,
  },
  data() {
    return {
      porPagina: this.perPage,
      statusFilter: null,
      statusOptions : ['Downloaded','Draft','Paid','Partial Payment','Past Due',],
      search: this.searchQuery
    }
  },
  computed:{
    ...mapState('fivesClubCatalogs', ['filter']),
  },
  methods:{
    ...mapMutations('fivesClubCatalogs',['setQueryFilter']),
    changePerPage( perPage ){
      this.$emit('change-per-page', perPage)
      this.porPagina = perPage
    },
    searchInRecords( query ){
      this.$emit('search-in-table-records', query)
      this.search = query
    },
    setFilter( string ){
      this.setQueryFilter(string.trim())
    },
    refreshData(){
      this.$emit('refresh-data')
    }
  }
}
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>